import heroBg from "@/assets/hero-bg-street.webp";
import heroImage from "@/assets/hero-circle-image.webp";
import { useLanguage } from "@/i18n/LanguageContext";
import { useCmsContent } from "@/hooks/useCmsContent";
import { getBookingUrl } from "@/lib/booking";

const Hero = () => {
  const { t, language } = useLanguage();
  const { get } = useCmsContent();
  return (
    <section className="relative h-[100svh] w-full overflow-hidden flex flex-col">
      <img src={heroBg} alt="" className="absolute inset-0 w-full h-full object-cover" aria-hidden="true" fetchPriority="high" />
      <div className="absolute inset-0 bg-primary/75" />
      <div className="relative z-10 flex flex-col items-center text-center px-4 pt-28 md:pt-40 shrink-0">
        <h1 className="font-display text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-semibold text-primary-foreground leading-tight">
          {get("hero_subtitle") || t.hero.welcome}{" "}
          <span className="italic" style={{ color: '#ffd990' }}>{get("hero_title") || t.hero.hotelName}</span>
          <br />
          {get("hero_location") || t.hero.location}
        </h1>
        <a
          href={getBookingUrl(language)}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-6 md:hidden inline-block px-8 py-3 bg-white text-foreground font-body text-xs uppercase tracking-[0.2em] font-semibold rounded-sm cursor-pointer shadow-elevated"
        >
          {t.nav.bookNow}
        </a>
      </div>
      <div className="relative z-10 flex-1 min-h-0 flex items-end justify-center mt-4 pb-0">
        <img
          src={heroImage}
          alt="Esos Hotel Quelle Bad Ragaz"
          className="max-h-full w-auto object-contain"
          style={{
            maxWidth: 'min(30rem, 80vw)',
            borderRadius: '50% 50% 0 0',
            border: '4px solid rgba(255, 217, 144, 0.4)',
            boxShadow: '0 10px 30px rgba(0,0,0,0.3)',
          }}
        />
      </div>
    </section>
  );
};

export default Hero;
